(function() {
  let tlYMALClone;
  
  Object.defineProperty(window, "tlYMAL", {
    get() {
      return tlYMALClone;
    },
    set(val) {
      if (val && !tlYMALClone) {
        tlYMALClone = val;
        val.checkCartData = async () => {
          if (window.location.pathname != "/cart") {
            return {
              productInCart: [window.productId?.toString()]
            }
          }

          const cartData = await window.tlYMAL.getCartAjax();
          const productInCart = new Set();
          const ruleIdMapAddedRecommendProd = new Map();

          cartData.items.forEach(item => {
            const productId = String(item.product_id);
            const ruleId = item.properties[window.tlYMAL.PROPERTY];
            if(ruleId){
              const addedRecommendProd = ruleIdMapAddedRecommendProd.get(ruleId) ?? [];
              ruleIdMapAddedRecommendProd.set(ruleId, [...addedRecommendProd, productId])
            }
            productInCart.add(productId)
          })
          window.tlYMAL.ruleIdMapAddedRecommendProd = new Map(ruleIdMapAddedRecommendProd);
          return { productInCart: Array.from(productInCart) }
        }
      }
    },
    configurable: true
  });
})();